export const MEDICAL_RECRUITMENT_NYC_ACCOUNT_ID = 'ACC_dloybrzln9ek22qs';

export interface CmReferralRoute {
  isCmMode: boolean;
  referringAccountId: string;
}

function getParam(params: URLSearchParams, name: string): string {
  for (const [key, value] of params.entries()) {
    if (key.toLowerCase() === name) return value.trim();
  }
  return '';
}

export function resolveCmReferralRoute(
  search: string,
  bakedInReferringAccountId = '',
): CmReferralRoute {
  const bakedInAccountId = bakedInReferringAccountId.trim();
  if (bakedInAccountId) {
    return {
      isCmMode: true,
      referringAccountId: bakedInAccountId,
    };
  }

  const params = new URLSearchParams(search);
  return {
    isCmMode: getParam(params, 'cm').toLowerCase() === 'true',
    referringAccountId: getParam(params, 'ra'),
  };
}
